import React, { useState } from 'react';

const HowToGuide = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleGuide = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="how-to-guide">
      <button 
        className="guide-toggle" 
        onClick={toggleGuide}
      >
        {isOpen ? 'Anleitung ausblenden ▲' : 'Anleitung einblenden ▼'}
      </button>
      
      {isOpen && (
        <div className="guide-content">
          <h3>Wie funktioniert der Changing-Teams Turnierplaner?</h3>
          
          <div className="guide-section">
            <h4>1. Spieler hinzufügen</h4>
            <p>Fügen Sie alle teilnehmenden Spieler hinzu. Geben Sie die Namen in das Feld „Spieler hinzufügen" ein und klicken Sie auf „Hinzufügen".</p>
            <p><strong>Tipp:</strong> Sie können Platzhalter (z.B. Spieler1, Spieler2) anlegen und später mit einem <strong>Doppelklick</strong> auf den Namen direkt umbenennen – auch nachdem das Turnier bereits generiert wurde.</p>
          </div>
          
          <div className="guide-section">
            <h4>2. Einstellungen festlegen</h4>
            <ul>
              <li><strong>Teams:</strong> Legen Sie die Anzahl der Teams fest (mind. 2).</li>
              <li><strong>Runden:</strong> Bestimmen Sie, wie viele Spielrunden stattfinden sollen.</li>
              <li><strong>Felder:</strong> Geben Sie an, wie viele Spielfelder zur Verfügung stehen.</li>
            </ul>
          </div>
          
          <div className="guide-section">
            <h4>3. Turnier generieren</h4>
            <p>Klicken Sie auf „Turnier generieren", um die Teams und den Spielplan zu erstellen. Das Besondere: In jeder Runde werden die Spieler neu auf die Teams verteilt!</p>
            <p>Die Teamverteilung erfolgt so, dass Spieler möglichst oft mit unterschiedlichen Mitspielern zusammenspielen.</p>
          </div>
          
          <div className="guide-section">
            <h4>4. Ergebnisse eintragen</h4>
            <p>Tragen Sie nach jeder Spielrunde die Ergebnisse in den Spielplan ein. Die Rangliste wird automatisch aktualisiert.</p>
            <p><em>Tipp: Fahren Sie mit der Maus über ein Team, um zu sehen, welche Spieler in diesem Team sind.</em></p>
          </div>
          
          <div className="guide-section">
            <h4>5. Spieler importieren/exportieren</h4>
            <ul>
              <li>📥 Klicken Sie auf „Vorlage (.csv)", um eine CSV-Vorlage herunterzuladen.</li>
              <li>📥 Nutzen Sie den „Import"-Button und wählen Sie Ihre ausgefüllte CSV-Datei, um Spieler hinzuzufügen.</li>
              <li>📤 Klicken Sie auf „Export", um Ihre aktuelle Spielerliste als CSV herunterzuladen.</li>
            </ul>
          </div>

          <div className="guide-section">
            <h4>6. Ausdruck</h4>
            <p>Klicken Sie auf die Schaltfläche „Matrix drucken" oberhalb der Turniermatrix, um die gesamte Matrix auszudrucken.</p>
            <p>Klicken Sie in der Match-Ansicht auf einen Spielernamen, um den individuellen Spielplan dieses Spielers auszudrucken.</p>
            <p>Klicken Sie im Spielplan auf ein Feld (z.B. "Feld 1"), um den Spielplan für dieses Feld auszudrucken. Dieser zeigt alle Spiele und Mannschaften, die auf diesem Feld spielen.</p>
          </div>

          <div className="guide-section">
            <h4>7. Turnier übertragen (Export / Import)</h4>
            <p>Sie können ein komplettes, bereits generiertes Turnier auf einen anderen Rechner übertragen:</p>
            <ul>
              <li><strong>Export (JSON):</strong> Im Bereich „Turnier Transfer" auf „Export" klicken. Es wird eine <code>.json</code>-Datei mit allen Spielern, Einstellungen, Runden, Team-Zuordnungen und Ergebnissen gespeichert.</li>
              <li><strong>Import (JSON):</strong> Auf „Import" klicken und die zuvor exportierte Datei auswählen. Nach Bestätigung wird der aktuelle Stand überschrieben.</li>
              <li>Nach dem Import können Sie sofort weiterarbeiten oder neue Ergebnisse eintragen.</li>
            </ul>
            <p><em>Tipp:</em> Nutzen Sie diese Funktion, um Turniere vorzubereiten und später auf dem Turnier-Rechner fortzusetzen.</p>
          </div>
          
          <div className="guide-section">
            <h4>Hinweise:</h4>
            <ul>
              <li>Alle Daten werden automatisch im Browser gespeichert.</li>
              <li>Sie können die App auch offline nutzen.</li>
              <li>Um alle Daten zurückzusetzen, klicken Sie auf „Alles zurücksetzen".</li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default HowToGuide;